import { render, staticRenderFns } from "./SocialBar.vue?vue&type=template&id=271c1727&scoped=true"
var script = {}
import style0 from "./SocialBar.vue?vue&type=style&index=0&id=271c1727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c1727",
  null
  
)

export default component.exports